export default {
    email : /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
    phone: /^[0-9]{10}$/,
    name: /[a-zA-Z]{3,}\D+/,
    nameSecondary: /^[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,40}(?: +[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,40})+$/,
    idCard: /^[0-9]{6,10}$/,
    idCardPhoneNumber: /^(?=3)\d{10}$|^\d{9}$/,
    idType: /(^Cédula de ciudadanía$|^Cédula de extranjería$)/,
}